import { render } from "./RequestsColumn.vue?vue&type=template&id=dbd12c2c&ts=true&lang=pug"
import script from "./RequestsColumn.vue?vue&type=script&lang=ts"
export * from "./RequestsColumn.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__